export function getErrorFromResponse(response) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if ((_a = response === null || response === void 0 ? void 0 : response.error) === null || _a === void 0 ? void 0 : _a.networkError) {
        return (((_g = (_f = (_e = (_d = (_c = (_b = response === null || response === void 0 ? void 0 : response.error) === null || _b === void 0 ? void 0 : _b.networkError) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.errors) === null || _e === void 0 ? void 0 : _e.map((e) => e === null || e === void 0 ? void 0 : e.message)) === null || _f === void 0 ? void 0 : _f.filter(Boolean)) === null || _g === void 0 ? void 0 : _g.join('; ')) || null);
    }
    if ((_h = response === null || response === void 0 ? void 0 : response.error) === null || _h === void 0 ? void 0 : _h.message) {
        return (_j = response === null || response === void 0 ? void 0 : response.error) === null || _j === void 0 ? void 0 : _j.message;
    }
}
export function remapData(result, dataKey) {
    var _a;
    const errorMessages = getErrorFromResponse(result);
    return Object.assign(Object.assign({}, result), { data: (_a = result.data) === null || _a === void 0 ? void 0 : _a[dataKey], error: errorMessages });
}
export function remapResponseHandler(mutateFunc, dataKey) {
    return async (data) => {
        const result = await mutateFunc({ variables: { data } });
        return remapData(result, dataKey);
    };
}
